module.exports = __webpack_public_path__ + "static/media/u2f_usb.591cc98f.png";